module.exports = __webpack_public_path__ + "img/1-5-1.b3e3ccf8.png";